import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class ReservationSource
 * @property {number} id
 * @property {Property} property
 * @property {string} name
 * @property {integer} status
 */
export class ReservationSource extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'name' ];
    }
    
    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
    
    static get validationModel() {
        
        return {
            name: {
                label: 'ENGLISH_SOURCE_NAME',
                commonLabel: 'Source name'
            },
            name_ar: {
                label: 'ARABIC_SOURCE_NAME',
                commonLabel: 'Source name'
            }
        };
    }
}

AccessorsMutatorsDecorator(
    'id',
    ...ReservationSource.translatableAttributesWithLanguageAliases,
    'property',
    'status',
    'editable',
    'taxes_fees',
    'default',
    'reservations_count',
)(ReservationSource);



// WEBPACK FOOTER //
// ./src/pms-api/models/reservation-source.model.js